import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const HOME_OVERVIEW_METRIC_SCHEMA = Object.freeze({
  DOC_COUNT: 0,
  TOTAL: 0,
});
const RECORD = generateSchema(HOME_OVERVIEW_METRIC_SCHEMA);
const KEYS: any = generateKeys(HOME_OVERVIEW_METRIC_SCHEMA);

export class HomeOverviewMetric extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get docCount(): number {
    return this.get(KEYS.DOC_COUNT);
  }

  get total(): number {
    return this.get(KEYS.TOTAL);
  }
}
